import api from '../services/api';
import Swal from 'sweetalert2';

export default function ChangePassword() {
  const container = document.createElement('div');
  container.innerHTML = ``;

  // dispara o Swal automaticamente
  Swal.fire({
    title: 'Alterar Senha',
    html: `
      <label for="senhaAtual" class="swal2-label" style="margin-bottom:5px;">Senha atual</label>
      <input id="senhaAtual" class="swal2-input" type="password" placeholder="Digite sua senha atual" style="margin:0;" />

      <label for="novaSenha" class="swal2-label" style="margin-top:10px;margin-bottom:5px;">Nova senha</label>
      <input id="novaSenha" class="swal2-input" type="password" placeholder="Digite a nova senha" style="margin:0;" />

      <label for="confirmarSenha" class="swal2-label" style="margin-top:10px;margin-bottom:5px;">Confirmar nova senha</label>
      <input id="confirmarSenha" class="swal2-input" type="password" placeholder="Confirme a nova senha" style="margin:0;" />
    `,
    confirmButtonText: 'Salvar',
    cancelButtonText: 'Cancelar',
    showCancelButton: true,
    focusConfirm: false,
    customClass: {
      actions: 'swal2-actions-custom'
    },
    preConfirm: async () => {
      const senhaAtual = document.getElementById('senhaAtual').value;
      const novaSenha = document.getElementById('novaSenha').value;
      const confirmarSenha = document.getElementById('confirmarSenha').value;

      if (novaSenha !== confirmarSenha) {
        Swal.showValidationMessage('A nova senha e a confirmação não coincidem');
        return;
      }


      try {
        const token = localStorage.getItem('token');
        await api.post('/alterarsenha', { senhaAtual, novaSenha }, {
          headers: { Authorization: `Bearer ${token}` }
        });
        Swal.fire('Sucesso', 'Senha alterada com sucesso!', 'success');
      } catch (error) {
        Swal.showValidationMessage(error.response?.data?.message || 'Erro ao alterar senha');
      }
    }
  });

  return container;
}
